import type { HelpFile } from '../../types/help'
import { MyTestIds } from '../../../testids/MyTestIds'

export const myHelp: HelpFile = {
  texts: {
    [MyTestIds.myRehiresBadge]:
      'Anzahl der Wiedereinstellungs-Kandidaten, deren übereinstimmende Identität Ihnen unterstellt ist und die auf Ihre Entscheidung warten.',
  },
}
